const normalizeUrl = (value) => String(value || '').trim().replace(/\/$/, '');

const socialLinks = [
  {
    name: 'Instagram',
    url: normalizeUrl(import.meta.env.VITE_INSTAGRAM_URL),
  },
  {
    name: 'TikTok',
    url: normalizeUrl(import.meta.env.VITE_TIKTOK_URL),
  },
  {
    name: 'YouTube',
    url: normalizeUrl(import.meta.env.VITE_YOUTUBE_URL),
  },
].filter((item) => item.url);

export const siteConfig = {
  name: 'Tripzy',
  locale: 'tr-TR',
  baseUrl: 'https://tripzytourapp.com',
  apiBaseUrl:
    normalizeUrl(import.meta.env.VITE_API_BASE_URL) ||
    'https://api.tripzytourapp.com/api',
  supportEmail: String(import.meta.env.VITE_SUPPORT_EMAIL || '').trim(),
  googlePlayUrl: normalizeUrl(import.meta.env.VITE_GOOGLE_PLAY_URL),
  turnstileSiteKey: String(
    import.meta.env.VITE_TURNSTILE_SITE_KEY || ''
  ).trim(),
  analyticsToken: String(
    import.meta.env.VITE_CLOUDFLARE_ANALYTICS_TOKEN || ''
  ).trim(),
  socialLinks,
};

export const routeMeta = {
  '/': {
    title: 'Tripzy — Geziyi keşfet, rotanı oluştur',
    description:
      'Yapay zekâ destekli gezi planları oluştur, yakınındaki yerleri keşfet ve rotanı kolayca yönet.',
  },
  '/privacy': {
    title: 'Gizlilik Politikası — Tripzy',
    description:
      'Tripzy uygulamasında işlenen veriler, kullanım amaçları ve gizlilik haklarınız.',
  },
  '/delete-account': {
    title: 'Hesap ve Veri Silme — Tripzy',
    description:
      'Tripzy hesabınızın ve ilişkili verilerinizin silinmesi için doğrulanmış başvuru oluşturun.',
  },
  '/contact': {
    title: 'İletişim ve Destek — Tripzy',
    description:
      'Destek, gizlilik, hesap silme veya geri bildirim konularında Tripzy ekibine ulaşın.',
  },
  '/terms': {
    title: 'Kullanım Koşulları — Tripzy',
    description:
      'Tripzy hesap, içerik, gezi planlama, rota ve premium abonelik kullanım koşulları.',
  },
};
